import { useCallback, useRef, useState } from 'react'
import AuthContext from './AuthProvider.context'
import { useDispatch, useSelector } from 'react-redux'
import { onSignInWithGoogle, onSignOut } from './AuthProvider.slice'
import SessionWatcher from './AuthProvider.sessionWatcher'
import PresenceTracker from './PresenceTracker'
import routes from '../../../../config/settings/routes'

const LOGOUT_FADE_IN_MS = 280
const LOGOUT_HOLD_MS = 240

const AuthProvider = ({ children }) => {
  const {
    error,
    isAuthenticated,
    loading,
    initialLoading,
    user,
  } = useSelector((state) => state.adminAuth)

  const dispatch = useDispatch()
  const signingOutRef = useRef(false)
  const [signingOut, setSigningOut] = useState(false)

  const logout = useCallback(async () => {
    if (signingOutRef.current) return
    signingOutRef.current = true
    setSigningOut(true)

    await new Promise((resolve) => setTimeout(resolve, LOGOUT_FADE_IN_MS))
    await dispatch(onSignOut())
    await new Promise((resolve) => setTimeout(resolve, LOGOUT_HOLD_MS))

    window.location.replace(routes.login)
  }, [dispatch])

  const signInWithGoogle = useCallback(async () => {
    dispatch(onSignInWithGoogle())
  }, [dispatch])

  return (
    <AuthContext.Provider
      value={{
        error,
        initialLoading,
        isAuthenticated,
        loading,
        logout,
        signingOut,
        signInWithGoogle,
        user,
      }}
    >
      {/* SessionWatcher:
        - Escucha los cambios de sesión globales (login/logout/token refresh).
        - Despacha las acciones correspondientes a Redux.
        PresenceTracker publica heartbeat de pestaña visible.
      */}
      <SessionWatcher />
      <PresenceTracker />
      {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider
